import { BipSummarySection } from './bip-summary.component';

// Example usage data structure
export const BIP_SUMMARY_DATA: BipSummarySection[] = [
  {
    stepNumber: 1,
    title: 'Category',
    content: {
      items: ['Aggression'],
    },
  },
  {
    stepNumber: 2,
    title: 'Behavior Types',
    content: {
      checkboxes: [{ label: 'Social / unstructured time', checked: true }],
      otherDescription: [
        'behaves in a very rude manner towards every other person',
      ],
    },
  },
  {
    stepNumber: 3,
    title: 'Operational Definition',
    content: {
      badges: [
        'Bites others',
        'Chokes others',
        'Grabs at others',
        'Hits others',
        'Kicks others',
        'Pinches others',
        'Pulls hair of others',
        'Pushes others',
        'Spits at others',
        'Verbally threatens others',
      ],
      description:
        'A specific description of a behavior that allows any observer to identify when the behavior has occurred. Rather than general labels such as "angry" or "aggressive," an operational definition would describe what an observer sees when a student engages in the target behavior. For example, an operational definition of "aggressive" might be, "attempts to hit others with another force to leave a red mark or cause bruising."',
    },
  },
  {
    stepNumber: 4,
    title: 'Frequency',
    content: {
      fields: [
        {
          label:
            'Which of the following best describes the frequency of the behavior?',
          value: 'It occurs almost always (every minute)',
        },
        {
          label: 'Once the behavior starts, how long does it usually last?',
          value: 'Duration does not matter or is instantaneous',
        },
        {
          label: 'On average how many times a minute does the behavior occur?',
          value: '1',
        },
      ],
    },
  },
  {
    stepNumber: 5,
    title: 'Intensity',
    content: {
      fields: [
        {
          label: 'How intense is the behavior when it occurs?',
          value:
            'Negligible (Does not impact others or risk creating a dangerous environment.)',
        },
      ],
    },
  },
  {
    stepNumber: 6,
    title: 'Environments',
    content: {
      checkboxes: [
        { label: 'During class time', checked: true },
        {
          label:
            'During transitions between classes, before school, or after school',
          checked: true,
        },
        { label: 'Social / unstructured time', checked: true },
        { label: 'Lunch', checked: true },
      ],
    },
  },
  {
    stepNumber: 7,
    title: 'Setting Events',
    content: {
      checkboxes: [
        { label: 'Poor sleep', checked: true },
        { label: 'Hungry', checked: true },
        { label: 'Sick', checked: true },
      ],
    },
  },
  {
    stepNumber: 8,
    title: 'Antecedents',
    content: {
      checkboxes: [
        {
          label: 'Normal transition from one location to another',
          checked: true,
        },
        { label: 'Unexpected transitions or changes', checked: true },
      ],
      otherDescription: [
        'When demands are placed on the student that are too difficult',
      ],
    },
  },
  {
    stepNumber: 9,
    title: 'Consequences',
    content: {
      checkboxes: [
        {
          label: 'Normal transition from one location to another',
          checked: true,
        },
        { label: 'Unexpected transitions or changes', checked: true },
      ],
      otherDescription: [
        'When demands are placed on the student that are too difficult',
      ],
    },
  },
  {
    stepNumber: 10,
    title: 'Goals',
    content: {
      questions: [
        { label: 'Goal 1', value: 'None' },
        { label: 'Goal 2', value: 'None' },
      ],
    },
  },
  {
    stepNumber: 11,
    title: 'Questions',
    content: {
      questions: [
        {
          label: 'What strategies have been tried previously?',
          value: 'Test 01',
        },
        {
          label:
            'Please provide the names and dates of everyone contributing to this BIP.',
          value: 'Test 02',
        },
        {
          label: 'Please provide your replacement behavior goal?',
          value: 'Test 03',
        },
      ],
    },
  },
];
